import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-picker-icon" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"display":"none"} }

import { ref, computed, watch } from 'vue'
import flatPickr from 'vue-flatpickr-component'
import { useDateTimeStore } from '@/stores/DateTimeFilterStore'
import { BaseOptions } from 'flatpickr/dist/types/options'
import calendar from '@/assets/svg/calendar.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'DatePicker',
  props: {
  isActive: Boolean
},
  emits: ['onOpen'],
  setup(__props, { emit: __emit }) {

const dateTimeStore = useDateTimeStore()

const emit = __emit

const props = __props

const flatpickr = ref<any>(null)
const datePickerDiv = ref<any>(null)

const config = ref<Partial<BaseOptions>>({
  wrap: true,
  altFormat: 'Y-m-d',
  altInput: true,
  dateFormat: 'Y-m-d',
  maxDate: 'today',
  monthSelectorType: 'static',
  position: 'below left',
  locale: {
    firstDayOfWeek: 1 // start week on Monday
  }
})

const datePicker = computed({
  get: () => dateTimeStore.date,
  set: (val) => dateTimeStore.setDate(val)
})

const activeClass = computed(() => `${props.isActive ? 'ms-date-picker-active' : ''}`)
const buttonFontStyle = computed(() => `${props.isActive ? 'NKT-P2-medium' : 'NKT-P2'}`)

const openDatePicker = () => {
  if (!props.isActive) {
    emit('onOpen')
    return
  }

  if (!flatpickr.value.fp.isOpen) {
    flatpickr.value.fp.open(undefined, datePickerDiv.value)
  }
}

watch(
  () => props.isActive,
  (newVal) => {
    if (newVal) {
      flatpickr.value.fp.open(undefined, datePickerDiv.value)
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      ref_key: "datePickerDiv",
      ref: datePickerDiv,
      class: _normalizeClass(["ms-date-picker", activeClass.value]),
      onClick: openDatePicker
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _unref(calendar),
          class: "icon"
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["date-picker-layout date-picker-style", [buttonFontStyle.value, activeClass.value]])
      }, _toDisplayString(datePicker.value), 3)
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(flatPickr), {
        hidden: "",
        ref_key: "flatpickr",
        ref: flatpickr,
        modelValue: datePicker.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datePicker).value = $event)),
        config: config.value,
        placeholder: "Select date",
        name: "date"
      }, null, 8, ["modelValue", "config"])
    ])
  ], 64))
}
}

})